import { FC } from 'react'
import classNames from 'classnames'
import { LinkButton } from '@/atoms/Button'
import { PayItForwardIcon } from '@/atoms/Icons/PayItForwardIcon'
import { CaptionSM } from '@/atoms/Text'
import { useTranslate } from '@/utils/translate/translate-client'

interface Props {
  theatricalSlug: string
  className?: string
}

export const TheatricalPifCta: FC<Props> = ({ theatricalSlug, className }) => {
  const { t } = useTranslate('tickets')

  return (
    <div className={classNames('flex flex-col gap-4 lg:flex-row lg:items-center', className)}>
      <CaptionSM color="core-gray-400">
        {t('pifOfferTicketMessage', 'Provide free tickets for someone to claim and watch at the movie theaters.')}
      </CaptionSM>

      <LinkButton
        className="flex shrink-0 items-center gap-1 !px-[20px] !py-[11px] !text-sm"
        href={`/pay-it-forward/${theatricalSlug}?utm_campaign=${theatricalSlug}-theatrical&utm_medium=web&utm_source=tickets-footer-ad#`}
        variant="white"
        prefetch
      >
        <PayItForwardIcon size={18} color="black" />
        {t('payItForward', 'Pay it Forward')}
      </LinkButton>
    </div>
  )
}
